import { makeVar, useReactiveVar } from "@apollo/client";

export const selectedLocationVariable = makeVar<string | null>(null);

export const useSelectedLocation = () =>
  useReactiveVar(selectedLocationVariable);
